(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (() => {
    const MIN_ZOOM = 1;
    const MAX_ZOOM = 4;
    const ZOOM_STEP = 0.5;
    const SWIPE_DISTANCE = 50;

    const clamp = (value, min, max) => {
      return Math.min(Math.max(value, min), max);
    };

    function getBestImageSource(image) {
      if (!image) return '';

      if (!image.srcset) {
        return image.currentSrc || image.src || '';
      }

      const candidates = image.srcset
        .split(',')
        .map((candidate) => {
          const parts = candidate.trim().split(/\s+/);
          const descriptor = parts[1] || '1x';
          const size = Number.parseFloat(descriptor);

          return {
            url: parts[0],
            size: Number.isFinite(size) ? size : 1,
          };
        })
        .sort((first, second) => second.size - first.size);

      return candidates[0]?.url || image.currentSrc || image.src || '';
    }

    function setupProductZoom(section) {
      if (!section || section.dataset.productZoomReady === 'true') {
        return;
      }

      const modal = section.querySelector('[data-product-zoom]');
      const media = section.querySelector('.product-information__media');
      const viewport = modal?.querySelector('[data-zoom-viewport]');
      const zoomImage = modal?.querySelector('[data-zoom-image]');
      const closeButton = modal?.querySelector('[data-zoom-close]');
      const previousButton = modal?.querySelector('[data-zoom-previous]');
      const nextButton = modal?.querySelector('[data-zoom-next]');
      const zoomInButton = modal?.querySelector('[data-zoom-in]');
      const zoomOutButton = modal?.querySelector('[data-zoom-out]');
      const resetButton = modal?.querySelector('[data-zoom-reset]');
      const levelLabel = modal?.querySelector('[data-zoom-level]');
      const counter = modal?.querySelector('[data-zoom-counter]');

      if (!modal || !media || !viewport || !zoomImage || !closeButton) {
        return;
      }

      section.dataset.productZoomReady = 'true';

      let images = [];
      let currentIndex = 0;
      let zoom = MIN_ZOOM;
      let previousFocus = null;
      let pointerStartX = 0;
      let pointerStartY = 0;
      let pointerStartTime = 0;

      function isProductImage(image) {
  if (!(image instanceof HTMLImageElement)) {
    return false;
  }

  if (!getBestImageSource(image)) {
    return false;
  }

  if (
    image.closest(
      'video, model-viewer, .product-zoom, [data-product-zoom]'
    )
  ) {
    return false;
  }

  return true;
}
      function collectImages() {
        const candidates = Array.from(media.querySelectorAll('img'))
          .filter(isProductImage);

        const sources = new Set();

        images = candidates.filter((image) => {
          const source = getBestImageSource(image);

          if (!source || sources.has(source)) {
            return false;
          }

          sources.add(source);
          return true;
        });

        images.forEach((image) => {
          image.classList.add('product-zoom-trigger');

          /*
           * No cambia el rol cuando la imagen ya se encuentra
           * dentro de un control interactivo de la galería.
           */
          if (!image.closest('button, a, [role="button"]')) {
            image.tabIndex = 0;
            image.setAttribute('role', 'button');
            image.setAttribute('aria-haspopup', 'dialog');

            image.setAttribute(
              'aria-label',
              image.alt
                ? `Ampliar imagen: ${image.alt}`
                : 'Ampliar imagen'
            );
          }
        });

        updateNavigation();
      }

      function updateNavigation() {
        const hasMultipleImages = images.length > 1;

        if (previousButton) {
          previousButton.hidden = !hasMultipleImages;
          previousButton.disabled = !hasMultipleImages;
        }

        if (nextButton) {
          nextButton.hidden = !hasMultipleImages;
          nextButton.disabled = !hasMultipleImages;
        }

        if (counter) {
          counter.textContent = images.length
            ? `${currentIndex + 1} / ${images.length}`
            : '0 / 0';
        }
      }

      function updateZoom(nextZoom) {
        zoom = clamp(nextZoom, MIN_ZOOM, MAX_ZOOM);

        zoomImage.style.transform = `scale(${zoom})`;
        zoomImage.classList.toggle('is-zoomed', zoom > MIN_ZOOM);

        if (levelLabel) {
          levelLabel.textContent = `${Math.round(zoom * 100)}%`;
        }

        if (zoomOutButton) {
          zoomOutButton.disabled = zoom <= MIN_ZOOM;
        }

        if (zoomInButton) {
          zoomInButton.disabled = zoom >= MAX_ZOOM;
        }
      }

      function resetZoom() {
        zoomImage.style.transformOrigin = '50% 50%';
        updateZoom(MIN_ZOOM);
      }

      function setZoomOrigin(clientX, clientY) {
        const rect = zoomImage.getBoundingClientRect();

        if (!rect.width || !rect.height) {
          return;
        }

        const originX = clamp(
          ((clientX - rect.left) / rect.width) * 100,
          0,
          100
        );

        const originY = clamp(
          ((clientY - rect.top) / rect.height) * 100,
          0,
          100
        );

        zoomImage.style.transformOrigin = `${originX}% ${originY}%`;
      }

      function showImage(index) {
        if (!images.length) {
          return;
        }

        currentIndex = (index + images.length) % images.length;

        const selectedImage = images[currentIndex];
        const source = getBestImageSource(selectedImage);

        resetZoom();

        zoomImage.src = source;
        zoomImage.alt = selectedImage.alt || '';

        updateNavigation();
      }

      function showPreviousImage() {
        showImage(currentIndex - 1);
      }

      function showNextImage() {
        showImage(currentIndex + 1);
      }

      function openZoom(triggerImage) {
  collectImages();

  if (!images.length) {
    return;
  }

  previousFocus = document.activeElement;

  const selectedIndex = images.indexOf(triggerImage);
  currentIndex = selectedIndex >= 0 ? selectedIndex : 0;

  modal.hidden = false;
  document.body.classList.add('product-zoom-open');

  showImage(currentIndex);
  closeButton.focus();
}

      function closeZoom() {
        modal.hidden = true;
        zoomImage.removeAttribute('src');

        resetZoom();

        if (!document.querySelector('[data-product-zoom]:not([hidden])')) {
          document.body.classList.remove('product-zoom-open');
        }

        if (
          previousFocus instanceof HTMLElement &&
          document.contains(previousFocus)
        ) {
          previousFocus.focus();
        }
      }

      collectImages();

media.addEventListener(
  'load',
  (event) => {
    if (event.target instanceof HTMLImageElement) {
      collectImages();
    }
  },
  true
);

const galleryObserver = new MutationObserver(() => {
        collectImages();
      });

      galleryObserver.observe(media, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset'],
      });

    media.addEventListener(
  'click',
  (event) => {
    const eventPath = event.composedPath();

    const triggerImage = eventPath.find(
      (element) =>
        element instanceof HTMLImageElement &&
        media.contains(element)
    );

    if (!triggerImage || !isProductImage(triggerImage)) {
      return;
    }

    const interactiveParent = triggerImage.closest(
      'button, a, [role="button"]'
    );

    const imageWidth =
      triggerImage.getBoundingClientRect().width ||
      triggerImage.width ||
      0;

    /*
     * Permite que las miniaturas pequeñas sigan cambiando
     * la imagen principal de la galería.
     */
    if (interactiveParent && imageWidth < 180) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    openZoom(triggerImage);
  },
  true
);

      media.addEventListener('keydown', (event) => {
        const triggerImage = event.target.closest(
          'img.product-zoom-trigger'
        );

        if (
          !triggerImage ||
          (event.key !== 'Enter' && event.key !== ' ')
        ) {
          return;
        }

        event.preventDefault();
        openZoom(triggerImage);
      });

      closeButton.addEventListener('click', closeZoom);

      previousButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        showPreviousImage();
      });

      nextButton?.addEventListener('click', (event) => {
        event.stopPropagation();
        showNextImage();
      });

      zoomInButton?.addEventListener('click', () => {
        updateZoom(zoom + ZOOM_STEP);
      });

      zoomOutButton?.addEventListener('click', () => {
        updateZoom(zoom - ZOOM_STEP);
      });

      resetButton?.addEventListener('click', resetZoom);

      zoomImage.addEventListener('click', (event) => {
        event.stopPropagation();

        if (zoom === MIN_ZOOM) {
          setZoomOrigin(event.clientX, event.clientY);
          updateZoom(2.5);
        } else {
          resetZoom();
        }
      });

      zoomImage.addEventListener('mousemove', (event) => {
        if (zoom > MIN_ZOOM) {
          setZoomOrigin(event.clientX, event.clientY);
        }
      });

      viewport.addEventListener(
        'wheel',
        (event) => {
          event.preventDefault();

          setZoomOrigin(event.clientX, event.clientY);

          const direction = event.deltaY < 0 ? 0.25 : -0.25;
          updateZoom(zoom + direction);
        },
        { passive: false }
      );

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse') {
          return;
        }

        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        pointerStartTime = Date.now();
      });

      viewport.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' || zoom > MIN_ZOOM) {
          return;
        }

        const distanceX = event.clientX - pointerStartX;
        const distanceY = event.clientY - pointerStartY;
        const elapsedTime = Date.now() - pointerStartTime;

        const isHorizontalSwipe =
          Math.abs(distanceX) >= SWIPE_DISTANCE &&
          Math.abs(distanceX) > Math.abs(distanceY) &&
          elapsedTime < 800;

        if (!isHorizontalSwipe) {
          return;
        }

        if (distanceX < 0) {
          showNextImage();
        } else {
          showPreviousImage();
        }
      });

      modal.addEventListener('click', (event) => {
        if (
          event.target === modal ||
          event.target === viewport
        ) {
          closeZoom();
        }
      });

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeZoom();
          return;
        }

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showPreviousImage();
          return;
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          showNextImage();
        }
      });
    }

    function initializeProductZoom(root = document) {
      const sections = [];

      if (
        root instanceof Element &&
        root.matches('.product-information')
      ) {
        sections.push(root);
      }

      root
        .querySelectorAll?.('.product-information')
        .forEach((section) => sections.push(section));

      sections.forEach(setupProductZoom);
    }

    initializeProductZoom();

    document.addEventListener('DOMContentLoaded', () => {
      initializeProductZoom();
    });

    document.addEventListener('shopify:section:load', (event) => {
      initializeProductZoom(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
